import { Checkbox, Col, DatePicker, Form, Input, InputNumber, Row } from 'antd'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import { useForceUpdate } from '../../../../elements/Hooks/useForceUpdate'
import UOM from '../../../../elements/Select/UOM'
import Taxes from '../../../../elements/Taxes'
import { get, isEmpty, round } from 'lodash'
import {
  defaultFormItemLayout,
  fullWidthFormItemLayout,
  rules,
  threeFormItemLayout,
} from '../../../../modules/FormItems'
import React, { useEffect, useState } from 'react'

import InfoTooltip from '../../../../elements/InfoTooltip'
import MaterialDetails from '../../../../elements/MaterialDetails'
import ShippingDetails from '../../../../elements/ShippingDetails'
import { dateVal } from '../../../../modules/Utils'

const { TextArea } = Input

function FeeForm(props) {
  const { line, list, order, price, onChangeUnit, isNew } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form

  const isFreight = get(order, 'category') === 'Freight'

  const deliveryDate = get(order, 'delivery.quantity') === 'Single' ? dateVal(order, 'delivery.date') : null

  //const Max = Math.max(...list.map((o) => o.no), 0) + 1
  const Max = ('000' + (list.length + 1)).slice(-2)
  const [vendorQuoteLine, setVendorQuoteLine] = useState({})

  const requisitions = get(order, 'reqs[0].reqs._id', '').replace('reqs/', '')

  const [ReqLinesSelect] = useFetchSelectUrl(
    {
      name: 'requisitionsLines',
      url: `requisitions/${requisitions}/lines`,
    },
    [requisitions],
    isEmpty(requisitions),
    undefined,
    (reqLine) => ({
      ...reqLine,
      display: `[${reqLine.no}] ${reqLine.name}`,
    })
  )

  const quoteId = (getFieldValue('vendorQuote._id') || '').replace('spquotes/', '')

  const VQOwner = (order.vendor._id || '').replace('members/', '')

  const [VendorQuoteSelect] = useFetchSelectUrl(
    {
      name: 'vendorQuotes',
      url: order.status === 'Draft' ? (`/vendorQuotes?select=_id,quoteNo,title&status=Confirmed&owner=${VQOwner}`) :
        (`/vendorQuotes?select=_id,quoteNo,title&owner=${VQOwner}`),
      cache: false,
    },
    [],
    undefined,
    undefined,
    ({ quoteNo, title, ...quote }) => ({
      display: `[${quoteNo}] ${title}`,
      ...quote,
    })
  )

  const [QuoteLineSelect] = useFetchSelectUrl(
    {
      name: 'quoteLines',
      url: `/vendorQuotes/lines/${quoteId}`,
      cache: false,
    },
    [quoteId],
    isEmpty(quoteId)
  )

  const rate = getFieldValue('rate') || 0
  const unit = getFieldValue('unit') || 0
  const [total, setTotal] = useState(rate * unit)

  React.useEffect(() => {
    setTotal(rate * unit)

    setFieldsValue({
      'tax.rate': (rate * getFieldValue('tax.percentage')) / 100.0,
    })
  }, [rate, unit])

  const forceUpdate = useForceUpdate()
  useEffect(() => {
    if (!isEmpty(vendorQuoteLine))
      setFieldsValue({
        description: get(line, 'description') || get(vendorQuoteLine, 'description'),
        'uom.code': get(line, 'uom.code') || get(vendorQuoteLine, 'uom.code'),
        rate: get(line, 'rate') || get(vendorQuoteLine, 'rate'),
        'tax.rate': get(line, 'tax.rate') || get(vendorQuoteLine, 'tax.rate'),
        'tax.percentage': get(line, 'tax.percentage') || get(vendorQuoteLine, 'tax.percentage'),
        'tax.type': get(line, 'tax.type') || get(vendorQuoteLine, 'tax.type'),
        shipping: get(line, 'shipping') || get(vendorQuoteLine, 'shipping'),
        materials: get(line, 'materials') || get(vendorQuoteLine, 'materials'),
      })
    forceUpdate()
  }, [vendorQuoteLine])

  return (
    <Form>
      {!isFreight && (
        <Row>
          <Col span={24}>
            <Form.Item
              {...fullWidthFormItemLayout}
              label={
                <InfoTooltip value={'Requisition Line'} title={'Requisition Line that this Order Line relates to.'} />
              }>
              {getFieldDecorator('reqLine._id', {
                initialValue: get(line, 'reqLine._id'),
                rules: rules.select,
              })(<ReqLinesSelect keyAtr={'_id'} valueAtr={'display'} style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
        </Row>
      )}
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Vendor Quotes">
            {getFieldDecorator('vendorQuote._id', {
              initialValue: get(line, 'vendorQuote._id'),
              // rules: rules.select,
            })(
              <VendorQuoteSelect
                keyAtr={'_id'}
                valueAtr={'display'}
                placeholder="Select a Quote"
                style={{ width: '100%' }}
              />
            )}
          </Form.Item>
        </Col>
        {quoteId && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Vendor Quotes Line">
              {getFieldDecorator('vendorQuoteLine._id', {
                initialValue: get(line, 'vendorQuoteLine._id'),
                // rules: rules.select,
              })(<QuoteLineSelect keyAtr={'_id'} setSelected={setVendorQuoteLine} valueAtr={'name'} />)}
            </Form.Item>
          </Col>
        )}
      </Row>
      <Row>
        <h3>Order Details</h3>
        <Col span={6}>
          <Form.Item {...defaultFormItemLayout} label={'Line No.'}>
            {getFieldDecorator('no', {
              initialValue: get(line, 'no', Max),
              rules: [{ required: true, message: 'Please Select a No!' }],
            })(<Input placeholder={'Line No'} style={{ width: '80%' }} />)}
          </Form.Item>
        </Col>
        <Col span={18}>
          <Form.Item {...defaultFormItemLayout} label={'Line Name'}>
            {getFieldDecorator('name', {
              initialValue: get(line, 'name'),
              rules: rules.input,
            })(<Input placeholder={'Line Name'} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <Form.Item {...fullWidthFormItemLayout} label={'Description'}>
            {getFieldDecorator('description', {
              initialValue: get(line, 'description'),
            })(<TextArea placeholder={'Description'} />)}
          </Form.Item>
        </Col>
        {!isFreight && (
          <Col span={8}>
            <Form.Item {...defaultFormItemLayout} label="Delivery Date">
              {getFieldDecorator('delivery.date', {
                initialValue: dateVal(line, 'delivery.date') || deliveryDate,
                rules: rules.date,
              })(<DatePicker style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
        )}
        <Col span={8}>
          <Form.Item
            {...threeFormItemLayout}
            label={
              <InfoTooltip
                value={'SUB-COMPONENT'}
                title={"If this component shouldn't count in against sales order line quantity."}
              />
            }>
            {getFieldDecorator('isSubcomponents', {
              initialValue: isNew || get(line, 'isSubcomponents'),
              valuePropName: 'checked',
            })(<Checkbox data-testid="isSubcomponent" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <h3>Rate Details</h3>
        <Taxes
          // doc={{
          //   ...{
          //     taxType: get(order, 'taxType', ''),
          //     tax: get(order, 'tax'),
          //   },
          //   ...line,
          // }}
          doc={line}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            resetFields,
            type: 'fee',
            price: rate,
          }}
        />
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label={'Unit(s)'}>
            {getFieldDecorator('unit', {
              initialValue: get(line, 'unit') || 1,
              rules: [{ required: true, message: 'Please Select a unit!' }],
            })(
              <Input
                type="number"
                style={{ width: '80%' }}
                addonAfter={
                  <span>{get(price, 'uom.name') || get(line, 'uom.code') || get(line, 'productLine.uom.key')}</span>
                }
                style={{ width: '100%' }}
                placeholder={'Quantity'}
                onChange={onChangeUnit}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label="UOM">
            {getFieldDecorator('uom.code', {
              initialValue: get(line, 'uom.code'),
              rules: rules.select,
            })(<UOM style={{ width: '80%' }} />)}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label={'Rate'}>
            {getFieldDecorator('rate', {
              initialValue: get(line, 'rate'),
              rules: rules.input,
            })(<InputNumber style={{ width: '80%' }} placeholder={'Rate'} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        {isFreight ? (
          <Col span={12} />
        ) : (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Dropshippable">
              {getFieldDecorator('isDropshippable', {
                initialValue: get(line, 'isDropshippable') || get(order, 'delivery.dropshippable'),
                valuePropName: 'checked',
              })(<Checkbox />)}
            </Form.Item>
          </Col>
        )}
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'TOTAL (NET)'}>
            <InputNumber style={{ width: '100%' }} disabled={true} value={total} placeholder={'Total'} />
          </Form.Item>
        </Col>
      </Row>

      {!isFreight && (
        <>
          {/*// PURCHASE MATERIAL DETAILS*/}
          <MaterialDetails
            line={line}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              resetFields,
              type: 'Purchase',
            }}
          />

          <ShippingDetails
            line={line}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              resetFields,
              type: 'Purchase',
            }}
          />
        </>
      )}
    </Form>
  )
}

export default Form.create()(FeeForm)
